import { IAdherence } from 'interfaces/dashboard';
import { Observable } from 'rxjs';
import apiService, { ApiService } from './api';

export class AdherenceService {
  constructor(private apiService: ApiService) {}

  fetch(categoryId?: number, snapshotId?: number): Observable<IAdherence[]> {
    return this.apiService.get('/adherence', { categoryId, snapshotId });
  }
}

const adherenceService = new AdherenceService(apiService);
export default adherenceService;
